import { Card, CardContent, Typography, CardHeader, Box, useTheme} from "@mui/material";

const CardComponent = (props: any) => {
const theme = useTheme()
const Styles = {
  root: (prop: any) => ({
    alignItems: 'flex-start',
    width: 'auto',
    height: '100px',
    padding: '24px',
    borderRadius: '18px',
  }),
  customCardNumber: { margin: '0px', marginTop: '0px'},
  customCardHeading: {
    padding: '0px',
    fontSize: '1rem !important',
    fontWeight: '400 !important',
    lineHeight: '22px',
    margin: '0px',
    color: theme.palette.text.primary ,
    marginTop: '5px',

    // width:'203px'
  },
  customCardBox: { display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItem:'center' },
  customCardNumLabel: {
    fontWeight: '600px',
    fontSize: '2.25rem !important',
    color: theme.palette.text.primary
  }
};


  const prop = {
    backgroundColor: 'black',
    hoverColor: 'red',
  };
  return (
    <Card sx={Styles.root}>
      <CardContent sx={{padding:'0px !important', display:'flex', flexDirection:'column', paddingBottom:'0px !important' }}>
        <Box sx={Styles.customCardBox}>
          <Typography sx={Styles.customCardHeading} > {props.title} </Typography>
          <Box sx={{
            height: "42px",
            width: "42px",
            backgroundColor: props.color ? props.color : 'grey',
            borderRadius: "24px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "white",
          }}>
            {props.icon}
          </Box>
        </Box>
        <Box sx={Styles.customCardNumber}>
          <Typography sx={Styles.customCardNumLabel}>
            {props.number}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CardComponent;
